module.exports = {
    gameNetworkId: 530
};



//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 15
// module chunks = 0